<template>
  <form>
    <p v-if="error" class="error">{{ error }}</p>
    <!-- <div class="form-group row">
      <input
        v-model="username"
        type="text"
        id="username"
        class="form-control"
        :placeholder="$t('email')"
        autofocus
        @keyup.enter="login()"
      />
    </div>
    <div class="form-group row">
      <input
        v-model="password"
        type="password"
        id="password"
        class="form-control"
        :placeholder="$t('password')"
        required
        @keyup.enter="login()"
      />
    </div> -->
    <div class="form-group">
      <b-row class="my-2 text-center">
        <b-col md="12">
          <!-- <pw-button id="login" :spinner="loading" className="success" @accepted="login()">
            <span class="icon">
              <i class="fa fa-sign-in-alt"></i>
              {{ $t("login") }}
            </span>
          </pw-button> -->
        </b-col>
        <b-col md="12">
          <br />
          <img src="../assets/images/ms-symbollockup_signin_light.png" @click="azureLogin" style="cursor: pointer" />
        </b-col>
      </b-row>
    </div>
  </form>
</template>

<script>
import AzureAuthService from "@/services/AzureAuthService";

export default {
  name: "LoginAdForm",
  props: {
    redirectRoute: { type: String, default: "home" }, // Route name
    redirectUrl: { type: String, default: null } // Route URL - takes precedence over route name if defined!
  },
  data() {
    return {
      username: null,
      password: null,
      error: null,
      loading: false
    };
  },
  mounted() {
    AzureAuthService.login(this.redirectUrl);
  },
  methods: {
    azureLogin() {
      AzureAuthService.login(this.redirectUrl);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
form {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: 50px auto auto auto;
}

.error {
  color: red;
}
</style>
